import Item from 'owa-service/lib/contract/Item';
import { isCancelledMeetingItemClass } from './isCancelledMeetingItemClass';

export const isMeetingCancelled = (item: Item) =>
    item?.__type === 'MeetingCancellationMessageType:#Exchange' ||
    !!isCancelledMeetingItemClass(item?.ItemClass);
